import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import { discussions } from '../components/content/discussions/store/store'
import { state } from './state'
import { mutations } from './mutations'
import { actions } from './actions'

Vue.use(Vuex)

export default new Vuex.Store({
  state: state,
  mutations: mutations,
  actions: actions,
  modules: {
    discussions
  },
  plugins: [createPersistedState()]
})
